export const TARGET_ATTRIBUTE = 'data-overflow-tooltip';

// Spread onto a view cell's truncating element. Edit-mode inputs need no marker.
export const overflowTooltipTarget = { [TARGET_ATTRIBUTE]: '' };
